import type { SVGProps } from 'react';
const SvgCurveLine = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={130} height={6} {...props}>
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#FFF"
      d="M.122 4.89q78.675-6.802 129 0"
    />
  </svg>
);
export default SvgCurveLine;
